import {UserSessionData} from "/@src/composable/useUserSession";
import axios, {AxiosResponse} from 'axios'
import {CommonResponse, DataResponse, SourceResponse} from "/@src/models/api";
import useNotyf from "/@src/composable/useNotyf";

const {error} = useNotyf()
export function createApiClients(session: UserSessionData) {
  return {
    default:createApiClient(session),
    sourceApi:createSourceClient(),
    dataApi:createDataClient(session),
  }
}

function createApiClient(session: UserSessionData){
  const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL as string,
  })
  api.interceptors.request.use((config) => {
    if(config.headers){
      if (session.token) {
        config.headers['X-Hufu-Token'] = session.token
        // 去除缓存
        config.headers['cache-control'] = 'no-store'
      }
      // 新接口没有v1标识
      if(config.url&&config.url.indexOf('/v1')<0){
        config.baseURL = import.meta.env.VITE_API2_BASE_URL as string
      }
    }

    return config
  })
  api.interceptors.response.use((response) => {
    // 判断是否完整路径请求外部数据
    if(!response.config.url!.startsWith('http')){
      const res = response.data as CommonResponse
      if (res.status === 1) {
        // 业务错误
        error(res.message!!)
        if(res.code === 50008||res.code === 50014){
          session.token = ''
        }else {
          throw new Error(res.message)
        }
      }
      const data = res.data
      return data
    }else {
      return response.data
    }

  },error => {
    if(error.message){
      error(error.message)
    }
  })
  return api
}

function createSourceClient() {
  const api = axios.create({
    baseURL: import.meta.env.VITE_API_SOURCE_BASE_URL as string,
  })
  api.interceptors.request.use((config) => {
    config.auth = {
      username:"wisburg",
      password:"NM51ejkTd"
    }
    return config
  })
  api.interceptors.response.use((response) => {
    const res = response.data as SourceResponse<any>
    if (res.status === 1) {
      // 业务错误
        if (res.msg?.includes('code: 404')){
            error('没有找到')
        } else {
            error(res.msg)
        }
      throw new Error(res.msg)
    }
    return res.data
  })
  return api
}

function createDataClient(session: UserSessionData) {
    const api = axios.create({
        baseURL: import.meta.env.VITE_API_DATA_BASE_URL as string,
    })
    api.interceptors.request.use((config) => {
        if(config.headers){
            if (session.token) {
                config.headers['x-token'] = session.token
            }
        }
        return config
    })
    api.interceptors.response.use((response) => {
        const res = response.data as DataResponse<any>
        // 业务错误
        if (res.status === 1) {
            if (res.msg?.includes('code: 404')){
                error('没有找到')
            } else {
                error(res.msg)
            }
            throw new Error(res.msg)
        }
        return res.data
    })
    return api
}
